

const navButtons = document.querySelectorAll('header nav button[data-name]')
const anchorTargets = document.querySelectorAll('main [data-name]')

if (navButtons.length && anchorTargets.length) {
	const getTargetByName = name => document.querySelector(`main [data-name="${name}"]`)
	const getButtonByName = name => document.querySelector(`header nav button[data-name="${name}"]`)
	const setActive = name => {
		navButtons.forEach(button => button.classList.toggle('active', button.dataset.name === name))
	}
	const setHash = name => {
		if (location.hash !== `#${name}`) history.replaceState(null, '', `#${name}`)
	}
	const scrollToTarget = name => {
		const target = getTargetByName(name)
		if (!target) return
		window.scrollTo({
			top: target.getBoundingClientRect().top + window.scrollY,
			behavior: 'smooth'
		})
	}
	const syncFromScroll = () => {
		let current = anchorTargets[0]
		const offset = window.innerHeight * 0.3
		anchorTargets.forEach(target => {
			if (target.getBoundingClientRect().top <= offset) current = target
		})
		if (!current) return
		const name = current.dataset.name
		setActive(name)
		setHash(name)
	}

	navButtons.forEach(button => {
		button.addEventListener('click', () => {
			const name = button.dataset.name
			setActive(name)
			setHash(name)
			scrollToTarget(name)
		})
	})

	window.addEventListener('scroll', syncFromScroll, { passive: true })
	window.addEventListener('load', () => {
		const name = location.hash.replace('#', '')
		if (name && getTargetByName(name)) {
			setActive(name)
			setTimeout(() => scrollToTarget(name), 0)
		} else {
			syncFromScroll()
		}
	})
	window.addEventListener('hashchange', () => {
		const name = location.hash.replace('#', '')
		if (!name || !getTargetByName(name)) return
		setActive(name)
		scrollToTarget(name)
	})
}